import axios from 'axios';
import * as TYPES from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setLogCheckTab = (data) => {
  if (data === null) {
    return { type: TYPES.LOG_CHECK_TAB_DATA, logCheckTabObj: {} };
  }
  return { type: TYPES.LOG_CHECK_TAB_DATA, logCheckTabObj: data };
};
export const getSaveAfterData = (data) => {
  if (data === null) {
    return { type: TYPES.SAVE_AFTER_LIST_DATA, saveAfterList: [] };
  }
  return { type: TYPES.SAVE_AFTER_LIST_DATA, saveAfterList: data };
};
export const dispatchGetGeneralSystemParametersResultDetails = (data) => ({
  type: TYPES.GET_GENERAL_SYSTEM_PARAMETER,
  generalSystemParameter: data,
});
export const getGeneralSystemParameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      dispatch(
        dispatchGetGeneralSystemParametersResultDetails(
          response.data && response.data.data
        )
      );
    })
    .catch(() => {
      dispatch(dispatchGetGeneralSystemParametersResultDetails([]));
    });
};

export const setLogCheckList = (data) => {
  return {
    type: TYPES.ADD_NEW_LOG_CHECK,
    logCheckList: data,
  };
};
export const maintainLogCheckListData = (payload, action) => {
  return (dispatch, getState) => {
    let dataArray = [...getState().sharedState.CheckLogReducer.logCheckList];
    if (payload === null) {
      dispatch(setLogCheckList([]));
    } else if (Array.isArray(payload) && action === 'verify') {
      dataArray = payload;
      dispatch(setLogCheckList(dataArray));
    } else {
      return axios
        .post(`${serviceEndPoint.CREATE_LOG_CHECK_SEQUENCE_NUM}`, {})
        .then((res) => {
          if (action === 'defaultRow') {
            const temp = [];
            payload.checkLogNum = res.data && res.data.data.checkLogNum;
            temp.push(payload);
            dispatch(setLogCheckList(temp));
          } else {
            const newObj = payload;
            newObj.checkLogNum = res.data && res.data.data.checkLogNum;
            dataArray.push(newObj);
            dispatch(setLogCheckList(dataArray));
          }
        })
        .catch(() => {
          dispatch(setLogCheckList(dataArray));
        });
    }
  };
};
export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: TYPES.SAVE_OR_UPDATE,
  };
};
export const postSaveOrUpdate = (value) => (dispatch) => {
  if (value === null) {
    dispatch(dispatchSaveOrUpdate(null));
  } else {
    return axios
      .post(serviceEndPoint.ADD_EDIT_LOG_CHECK, value)
      .then((response) => {
        return (
          dispatch(
            dispatchSaveOrUpdate({ ...response.data, message: 'SUCCESS' })
          ),
          dispatch(
            getSaveAfterData(
              response.data && response.data.data.saveLogCheckResponseVO
            )
          )
        );
      })
      .catch(() => {
        dispatch(dispatchSaveOrUpdate('failed'));
        dispatch(getSaveAfterData([]));
      });
  }
};
export const clearReduxLogCheckScreen = () => (dispatch) => {
  dispatch(setLogCheckTab({}));
  dispatch(maintainLogCheckListData(null));
  dispatch(dispatchGetGeneralSystemParametersResultDetails([]));
  dispatch(setLogCheckList([]));
  dispatch(dispatchSaveOrUpdate(''));
};
